import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  listContainer: { flex: 1, gap: 12, flexDirection: 'row' },
});
